import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiHeart } from 'react-icons/fi'; // Import the FiHeart icon

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent
    ? React.createElement(IconComponent, props)
    : <FiHeart {...props} />; // Use FiHeart as the fallback icon
};

export default SafeIcon;